import Session from "@lib/session";
import useContent from "@lib/use_content";
import userProfileAddPud from "@services/user_profile_add_pud";
import userProfileEditPud from "@services/user_profile_update_pud";
import { useState } from "react";
import { OnSubmitData } from "../Form/useFormSubmit";

export default function useLocationUpdate() {
  const { data: contentData } = useContent([
    "beErrProfileLocationsAdd",
    "beErrProfileLocationsUpdate",
    "beProfileLocationsAddSuccess",
    "beProfileLocationsUpdateSuccess",
  ]);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const userId = Session.getBooking().profiles.user;

  async function updateLocation(data: OnSubmitData, onSuccess: () => void): Promise<void> {
    setErrorMessage("");
    setSuccess("");
    if (!data.location.code) return;
    const isEdit = data.location.id;

    setSubmitting(true);
    const success = isEdit
      ? await userProfileEditPud(userId as number, data)
      : await userProfileAddPud(userId as number, data);

    if (!success) {
      setErrorMessage(
        (isEdit
          ? contentData?.content.beErrProfileLocationsUpdate
          : contentData?.content.beErrProfileLocationsAdd) || "",
      );
    } else {
      onSuccess();
      setSuccess(
        (isEdit
          ? contentData?.content.beProfileLocationsUpdateSuccess
          : contentData?.content.beProfileLocationsAddSuccess) || "",
      );
    }

    setSubmitting(false);
  }

  async function clearSuccessAndEdit() {
    setSuccess("");
    setErrorMessage("");
  }

  return { updateLocation, errorMessage, success, submitting, clearSuccessAndEdit };
}
